/**
 * file-templates.ts
 *
 * Minimal starter templates for each creatable project file type.
 * Used by NewFileDialog when the user creates a new blank file.
 */

export const SCAD_MODULE_TEMPLATE = `// New OpenSCAD module

module my_module() {
  cube([10, 10, 10]);
}

my_module();
`;

export const SVG_TEMPLATE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100">
  <!-- Add shapes here -->
  <rect x="10" y="10" width="80" height="80" fill="none" stroke="black" stroke-width="2"/>
</svg>
`;

export const JS_SHADER_TEMPLATE = `// Shader script — applied via shader_material("filename.js") in OpenSCAD.
// Both vertexShader and fragmentShader exports are required.
// Built-in: uColor (vec3 from color()), plus Three.js attributes
//           position, normal, uv, modelViewMatrix, projectionMatrix.

export const vertexShader = \`
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
\`;

export const fragmentShader = \`
  uniform vec3 uColor;
  varying vec2 vUv;
  void main() {
    gl_FragColor = vec4(uColor * vUv.x, 1.0);
  }
\`;

// Optional: declare custom uniforms.
// export const uniforms = {
//   uTime: { value: 0.0 },
// };

// Optional: update uniforms each frame (elapsedMs = time since first frame).
// export const tick = (uniforms, params, props, elapsedMs) => {
//   uniforms.uTime.value = elapsedMs * 0.001;
// };
`;

export const JS_TEXTURE_TEMPLATE = `// Texture script — applied via texture_script("filename.js") in OpenSCAD.
// Renders to a 2D canvas and streams frames to the viewer as a texture.

export const width = 512;
export const height = 512;

// fps: 0 = static (render once), undefined = uncapped, N = throttled to N fps
export const fps = 0;

const canvas = self.__canvas__;
const ctx = canvas.getContext('2d');

function draw() {
  ctx.clearRect(0, 0, width, height);

  // Background
  ctx.fillStyle = '#1a1a2e';
  ctx.fillRect(0, 0, width, height);

  // Example: centered circle
  ctx.beginPath();
  ctx.arc(width / 2, height / 2, width * 0.3, 0, Math.PI * 2);
  ctx.fillStyle = '#e94560';
  ctx.fill();

  self.__sendFrame__();
}

draw();
`;

export const JS_SVG_TEMPLATE = `// SVG script — used via js_svg(props=["filename", "my_script.js", "value", i]) in OpenSCAD.
//
// Called once per unique value to produce a standalone SVG string.
// The generated SVGs are written to the WASM virtual filesystem before compilation,
// and js_svg() calls are rewritten to import() calls automatically.
//
// Globals available:
//   props   — { filename, value, ...any extra keys you put in props=[] }
//   params  — live SCAD parameters (same object as in texture scripts)
//   sendSVG(svgString) — call this once to return the generated SVG

const value = props.value ?? 0;    // the per-instance discriminator (e.g. loop variable i)

// Size and style can be driven by value or params
const size = 80 + Number(value) * 5;
const hue = (Number(value) * 40) % 360;

sendSVG(\`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <circle cx="50" cy="50" r="\${size / 2}"
    fill="hsl(\${hue}, 70%, 50%)"
    stroke="white" stroke-width="2"/>
  <text x="50" y="55" text-anchor="middle"
    font-family="sans-serif" font-size="20" fill="white">
    \${value}
  </text>
</svg>\`);
`;

export const JSON_TEMPLATE = `{}
`;

export const TXT_TEMPLATE = ``;

export const DAT_TEMPLATE = `# Height map data
# Each row is a line of space-separated float values.
# Example: 3×3 flat surface at height 0
0 0 0
0 0 0
0 0 0
`;

export const DXF_TEMPLATE = `  0
SECTION
  2
ENTITIES
  0
LINE
  8
0
 10
0.0
 20
0.0
 30
0.0
 11
100.0
 21
0.0
 31
0.0
  0
ENDSEC
  0
EOF
`;
